// import React, { useState } from 'react';
// import translations from '../../utils/language/translations.json';
// import { useTranslation } from 'react-i18next';
// const FAQ = () => {
//   const [selectedQuestion, setSelectedQuestion] = useState(null);

//   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//   const currentLang = i18n.language; // Access the current language
//   const t = (key) => translations.FAQ[key][currentLang]; // Adjust the path according to your JSON structure
//   // Adjust the path according to your JSON structure

//   const handleQuestionClick = (faqKey) => {
//     if (selectedQuestion === faqKey) {
//       setSelectedQuestion(null);
//     } else {
//       setSelectedQuestion(faqKey);
//     }
//   };

//   return (
//     <div className="faq-container">
//       <h1>{t("FAQ_Title")}</h1>
//       <div className="faq-list">
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ1")}>
//             {t("FAQ1")}
//           </button>
//           {selectedQuestion === "FAQ1" && (
//             <div className="faq-answer">
//               <p>{t("FAQ1_A")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ2")}>
//             {t("FAQ2")}
//           </button>
//           {selectedQuestion === "FAQ2" && (
//             <div className="faq-answer">
//               <p>{t("FAQ2_A")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ3")}>
//             {t("FAQ3")}
//           </button>
//           {selectedQuestion === "FAQ3" && (
//             <div className="faq-answer">
//               <p>{t("FAQ3_A")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ4")}>
//             {t("FAQ4")}
//           </button>
//           {selectedQuestion === "FAQ4" && (
//             <div className="faq-answer">
//               <p>{t("FAQ4_A")}</p>
//               <p>{t("FAQ4_A1")}</p>
//               <p>{t("FAQ4_A2")}</p>
//               <p>{t("FAQ4_A3")}</p>
//               <p>{t("FAQ4_A4")}</p>
//               <p>{t("FAQ4_A5")}</p>
//               <p>{t("FAQ4_A6")}</p>
//               <p>{t("FAQ4_A7")}</p>
//               <p>{t("FAQ4_A8")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ5")}>
//             {t("FAQ5")}
//           </button>
//           {selectedQuestion === "FAQ5" && (
//             <div className="faq-answer">
//               <p>{t("FAQ5_A")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ6")}>
//             {t("FAQ6")}
//           </button>
//           {selectedQuestion === "FAQ6" && (
//             <div className="faq-answer">
//               <p>{t("FAQ6_A")}</p>
//             </div>
//           )}
//         </div>
//         <div className="faq-item">
//           <button onClick={() => handleQuestionClick("FAQ7")}>
//             {t("FAQ7")}
//           </button>
//           {selectedQuestion === "FAQ7" && (
//             <div className="faq-answer">
//               <p>{t("FAQ7_A")}</p>
//               <p>{t("FAQ7_A1")}</p>
//               <p>{t("FAQ7_A2")}</p>
//               <p>{t("FAQ7_A3")}</p>
//               <p>{t("FAQ7_A4")}</p>
//             </div>
//           )}
//         </div>
//         {/* Add more sections for each FAQ question */}
//       </div>
//     </div>
//   );
// };

// export default FAQ;

import React, { useState } from "react";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from "react-icons/fa"; // Icons
import "./FAQ.scss"; // Import styles
import SeoHelmet from '../../Seo/SeoHelmet';
const FAQ = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.FAQ[key][currentLang];

  // List of FAQs with long-answer handling
  const faqData = [
    { key: "FAQ1", label: t("FAQ1"), answer: t("FAQ1_A") },
    { key: "FAQ2", label: t("FAQ2"), answer: t("FAQ2_A") },
    { key: "FAQ3", label: t("FAQ3"), answer: t("FAQ3_A") },
    {
      key: "FAQ4",
      label: t("FAQ4"),
      answer: [
        t("FAQ4_A"),
        t("FAQ4_A1"),
        t("FAQ4_A2"),
        t("FAQ4_A3"),
        t("FAQ4_A4"),
        t("FAQ4_A5"),
        t("FAQ4_A6"),
        t("FAQ4_A7"),
        t("FAQ4_A8"),
      ],
    },
    { key: "FAQ5", label: t("FAQ5"), answer: t("FAQ5_A") },
    { key: "FAQ6", label: t("FAQ6"), answer: t("FAQ6_A") },
    {
      key: "FAQ7",
      label: t("FAQ7"),
      answer: [
        t("FAQ7_A"),
        t("FAQ7_A1"),
        t("FAQ7_A2"),
        t("FAQ7_A3"),
        t("FAQ7_A4"),
      ],
    },
    { key: "FAQ8", label: t("FAQ8"), answer: t("FAQ8_A") },
    { key: "FAQ9", label: t("FAQ9"), answer: t("FAQ9_A") },
    { key: "FAQ10", label: t("FAQ10"), answer: t("FAQ10_A") },
  ];

  return (
    <section className="faq-container">
       <SeoHelmet type="faq" />
      <h1 className="faq-title">{t("FAQ_Title")}</h1>
      <div className="faq-list">
        {faqData.map((faq) => (
          <div key={faq.key} className="faq-item">
            <button onClick={() => setSelectedQuestion(selectedQuestion === faq.key ? null : faq.key)} className="faq-question">
              <FaQuestionCircle className="faq-icon" /> {faq.label}
              {selectedQuestion === faq.key ? <FaChevronUp className="arrow" /> : <FaChevronDown className="arrow" />}
            </button>
            {selectedQuestion === faq.key && (
              <div className="faq-answer">
                {/* Render long answers as a bullet list */}
                {Array.isArray(faq.answer) ? (
                  <ul>
                    {faq.answer.map((text, idx) => (
                      <li key={idx}>{text}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{faq.answer}</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
